<footer class="border-blue-750 mt-10 flex flex-col items-center justify-center border-t border-solid px-2.5 py-8">
  <ul class="flex flex-col flex-wrap items-center justify-center gap-6 md:flex-row md:gap-0">
    <li class="border-blue-750 border-r md:my-3 md:px-4 lg:px-6">
      <a
        href="{{ mainSiteUrl }}"
        target="_blank"
        gtmLinkClick="footer_click"
        class="text-sm font-medium leading-tight text-neutral-100"
        data-testid="main-site-footer"
      >
        Main Site
      </a>
    </li>
    <li class="border-blue-750 border-r md:my-3 md:px-4 lg:px-6">
      <a
        [routerLink]="residentialUrl"
        gtmLinkClick="footer_click"
        class="text-sm font-medium leading-tight text-neutral-100"
        data-testid="residential-services-footer"
        >Residential Services</a
      >
    </li>
    <li class="border-blue-750 border-r md:my-3 md:px-4 lg:px-6">
      <a
        [routerLink]="commercialUrl"
        gtmLinkClick="footer_click"
        class="text-sm font-medium leading-tight text-neutral-100"
        data-testid="commercial-services-footer"
        >Commercial Services</a
      >
    </li>
    <li class="border-blue-750 border-r md:my-3 md:px-4 lg:px-6">
      <a
        href="{{ contactUsUrl }}"
        target="_blank"
        gtmLinkClick="footer_click"
        class="text-sm font-medium leading-tight text-neutral-100"
        data-testid="contact-us-footer"
      >
        Contact Us
      </a>
    </li>
    <li class="border-blue-750 border-r md:my-3 md:px-4 lg:px-6">
      <a
        href="{{ privacyUrl }}"
        target="_blank"
        gtmLinkClick="footer_click"
        class="text-sm font-medium leading-tight text-neutral-100"
        data-testid="privacy-policy-footer"
      >
        Privacy Policy
      </a>
    </li>
    <li class="px-4 md:my-3 lg:px-6">
      <a
        href="{{ termsUrl }}"
        target="_blank"
        gtmLinkClick="footer_click"
        class="text-sm font-medium leading-tight text-neutral-100"
        data-testid="terms-of-use-footer"
      >
        Terms of Use
      </a>
    </li>
  </ul>
  <small class="mt-10 text-center text-sm font-normal leading-tight text-gray-600">
    &copy; {{ currentYear }} Casella Waste Systems, Inc. All Rights Reserved.
  </small>
</footer>
